import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Book, Trophy, CheckCircle2, Check, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { trackButtonClick, trackStandardEvent } from '../utils/pixel';
export function PricingSection() {
  const handleMegaKitClick = () => {
    trackButtonClick('Pricing - Comprar MegaKit');
    trackStandardEvent('InitiateCheckout', {
      content_name: 'MegaKit Plan de Calma',
      value: 19990,
      currency: 'ARS'
    });
  };
  const handlePlanTotalClick = () => {
    trackButtonClick('Pricing - Comprar Plan Total');
    trackStandardEvent('InitiateCheckout', {
      content_name: 'Plan de Calma Total',
      value: 29990,
      currency: 'ARS'
    });
  };
  return <section className="py-20 md:py-28 bg-cream" id="pricing" data-id="element-238">
      <div className="container mx-auto px-4" data-id="element-239">
        <SectionWrapper data-id="element-240">
          <div className="text-center mb-16" data-id="element-241">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-6" data-id="element-242">
              Elegí tu plan y empezá hoy
            </h2>
            <p className="text-xl text-dark-green/80 font-poppins max-w-2xl mx-auto font-medium" data-id="element-243">
              Acceso inmediato a todo el material para descargar y leer a tu
              ritmo.
            </p>
          </div>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-start" data-id="element-244">
          {/* MegaKit - Featured */}
          <SectionWrapper delay={0.2} data-id="element-245">
            <div className="bg-white rounded-3xl border-2 border-sage p-8 md:p-10 relative shadow-[0_10px_40px_rgba(122,158,126,0.15)] flex flex-col h-full transform md:-translate-y-4 z-10" data-id="element-246">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-dark-green text-white px-6 py-2 rounded-full text-sm font-poppins font-bold tracking-wide shadow-lg whitespace-nowrap" data-id="element-247">
                ⭐ LO MÁS ELEGIDO
              </div>

              <div className="text-center mb-8 mt-4" data-id="element-248">
                <h3 className="text-2xl md:text-3xl font-playfair font-bold text-dark-green mb-3" data-id="element-249">
                  MegaKit Plan de Calma
                </h3>
                <p className="text-dark-green/70 font-poppins text-sm md:text-base mb-6 font-medium" data-id="element-250">
                  El sistema completo para berrinches
                </p>
                <div className="flex justify-center items-baseline gap-3 mb-3" data-id="element-251">
                  <span className="text-2xl text-dark-green/40 line-through font-poppins font-medium" data-id="element-252">
                    $39.990
                  </span>
                  <span className="text-5xl md:text-6xl font-playfair font-bold text-dark-green" data-id="element-253">
                    $19.990
                  </span>
                </div>
                <p className="text-sage text-sm font-poppins font-bold uppercase tracking-wider" data-id="element-254">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <div className="space-y-4 mb-10 flex-grow bg-offwhite p-6 rounded-2xl border border-sage/10" data-id="element-255">
                <div className="flex items-start gap-3" data-id="element-256">
                  <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-257" />
                  <span className="text-dark-green/90 font-poppins font-medium" data-id="element-258">
                    Los 6 Tomos del Plan de Calma
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-259">
                  <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-260" />
                  <span className="text-dark-green/90 font-poppins font-medium" data-id="element-261">
                    Los 9 Bonos Estratégicos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-262">
                  <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-263" />
                  <span className="text-dark-green/90 font-poppins font-medium" data-id="element-264">
                    Tarjetas de Rutinas Visuales
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-265">
                  <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-266" />
                  <span className="text-dark-green/90 font-poppins font-medium" data-id="element-267">
                    Guía de Frases Salvavidas
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-268">
                <a href="https://bovedadigital.online/cart/46514025169035:1" onClick={handleMegaKitClick} className="w-full py-5 min-h-[54px] bg-dark-green hover:bg-[#23472a] text-white font-poppins font-bold text-lg md:text-xl rounded-xl transition-all duration-300 shadow-[0_8px_20px_rgba(45,90,53,0.2)] hover:shadow-[0_12px_25px_rgba(45,90,53,0.3)] transform hover:-translate-y-1 text-center flex items-center justify-center gap-2" data-id="element-269">
                  → Quiero empezar hoy mismo
                </a>

                <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-dark-green/60 font-poppins font-medium" data-id="element-270">
                  <span className="flex items-center gap-1.5" data-id="element-271">
                    <ShieldCheck size={14} className="text-sage" data-id="element-272" /> Garantía 7
                    días
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-273">
                    <Lock size={14} className="text-sage" data-id="element-274" /> Pago seguro
                  </span>
                  <span className="flex items-center gap-1.5 w-full justify-center mt-1" data-id="element-275">
                    <CreditCard size={14} className="text-sage" data-id="element-276" /> MercadoPago ·
                    Tarjeta · Transferencia
                  </span>
                </div>
              </div>
            </div>
          </SectionWrapper>

          {/* Plan Total - Upgrade */}
          <SectionWrapper delay={0.4} data-id="element-277">
            <div className="bg-white rounded-3xl border border-sage/20 p-8 relative flex flex-col h-full shadow-sm mt-8 md:mt-0" data-id="element-278">
              <div className="text-center mb-8" data-id="element-279">
                <div className="mb-4 inline-block text-terracotta font-poppins text-xs font-bold tracking-widest uppercase bg-terracotta/10 px-3 py-1 rounded-full" data-id="element-280">
                  UPGRADE OPCIONAL
                </div>
                <h3 className="text-xl md:text-2xl font-playfair font-bold text-dark-green mb-2" data-id="element-281">
                  Plan de Calma Total
                </h3>
                <p className="text-dark-green/70 font-poppins text-sm mb-6 font-medium" data-id="element-282">
                  ¿Querés resolver también los límites desde la raíz?
                </p>
                <div className="flex justify-center items-baseline gap-2 mb-2" data-id="element-283">
                  <span className="text-xl text-dark-green/40 line-through font-poppins font-medium" data-id="element-284">
                    $59.990
                  </span>
                  <span className="text-4xl md:text-5xl font-playfair font-bold text-dark-green" data-id="element-285">
                    $29.990
                  </span>
                </div>
                <p className="text-sage text-sm font-poppins font-bold uppercase tracking-wider" data-id="element-286">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <div className="space-y-4 mb-10 flex-grow" data-id="element-287">
                <div className="p-4 bg-sage/10 rounded-xl border border-sage/20 mb-6" data-id="element-288">
                  <p className="text-dark-green font-poppins text-sm font-bold text-center" data-id="element-289">
                    Todo lo del MegaKit + Expansión "Límites con Amor"
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-290">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-291" />
                  <span className="text-dark-green/80 font-poppins text-sm" data-id="element-292">
                    <strong className="text-dark-green" data-id="element-293">Tomo 7:</strong> Límites
                    sin Gritos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-294">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-295" />
                  <span className="text-dark-green/80 font-poppins text-sm" data-id="element-296">
                    <strong className="text-dark-green" data-id="element-297">Tomo 8:</strong>{' '}
                    Consecuencias vs Castigos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-298">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-299" />
                  <span className="text-dark-green/80 font-poppins text-sm" data-id="element-300">
                    <strong className="text-dark-green" data-id="element-301">Tomo 9:</strong> Gestión
                    de la Frustración
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-302">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-303" />
                  <span className="text-dark-green/80 font-poppins text-sm" data-id="element-304">
                    <strong className="text-dark-green" data-id="element-305">Tomo 10:</strong>{' '}
                    Acuerdos Familiares
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-306">
                <a href="https://bovedadigital.online/cart/46518532046987:1" onClick={handlePlanTotalClick} className="w-full py-4 min-h-[54px] bg-white hover:bg-sage/5 text-dark-green border-2 border-dark-green font-poppins font-bold text-lg rounded-xl transition-all duration-300 text-center flex items-center justify-center gap-2" data-id="element-307">
                  → Quiero el sistema completo
                </a>
              </div>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}